import {Component} from '@angular/core';
import {AuthService} from '../shared/services/auth.service';
import {ActivatedRoute} from '@angular/router';
import {isUUID} from '../shared/utils/utils';
import {GenericApiResponse} from "@webmate-web-core/shared/api/apibase.api";

@Component({
    selector: 'wm-confirm-reset-password',
    styleUrls: ['./confirm-reset.component.less'],
    templateUrl: './confirm-reset.component.html'
})
export class ConfirmResetPasswordComponent {

    password: string = '';
    repeatPassword: string = '';

    requestSuccess: boolean = false;
    requesting: boolean = false;
    resetToken?: string;
    resetTokenValid: boolean = false;
    error?: string | GenericApiResponse = undefined;

    constructor(private authService: AuthService, private route: ActivatedRoute) {
    }

    ngOnInit() {
        this.resetToken = this.route.snapshot.queryParamMap.get('reset') ?? '';
        this.resetTokenValid = isUUID(this.resetToken);
    }

    confirmResetPassword() {
        if (this.valid()) {
            this.requesting = true;
            this.error = undefined;
            this.authService.resetPassword(this.password, this.resetToken!).subscribe(
                result => {
                    this.requesting = false;
                    this.requestSuccess = true;
                },
                error => {
                    console.error('Error resetting password: ', error);
                    this.error = error.error;
                    this.requesting = false;
                }
            );
        }
    }

    valid() {
        return this.password.trim().length > 0 && this.password === this.repeatPassword && this.resetTokenValid;
    }

}
